import React from 'react'
import { Button} from 'react-bootstrap'
import { FaFileDownload} from 'react-icons/fa'
import { useStateAuthContext, useStateHostContext } from '../context';

const Opd_rekomendasi_pajak = () => {
    const { STATE_AUTH } = useStateAuthContext();
    const { HOST } = useStateHostContext();
    const [data_rekomendasi, setData_rekomendasi] = React.useState([])
    const [loading, setLoading] = React.useState(false);

    const handleGetData = React.useCallback(async () => {
        setLoading(true);
        try {
            const param = {
                method: 'GET',
                headers: {
                    'REST-TOKEN': STATE_AUTH.token,
                    'REST-ID-OPD': STATE_AUTH.id_opd
                }
            }
            const requ = await fetch(HOST + `/rekom_pajak/opd/${STATE_AUTH.id_opd}`, param)
            const resp = await requ.json()

            if (requ.ok) {
                if (resp.s === true) {
                    setData_rekomendasi(resp.d)
                }
            }
        } catch (error) {
            console.log(error)
        } finally {
            setLoading(false);
        }
    }, [HOST, STATE_AUTH])


    React.useEffect(() => {
        handleGetData()
    }, [handleGetData])

    const handleDownloadSurat = async (path) => {
        try {
            const fd = new FormData();
            fd.append('FILE', path);
            const response = await fetch(HOST + '/rekom_pajak/download', {
                method: 'POST',
                headers: {
                    'REST-TOKEN': STATE_AUTH.token,
                    'REST-ID-OPD': STATE_AUTH.id_opd
                },
                body: fd
            });
            const blob = await response.blob();
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = url;
            a.download = path;
            a.click();
            window.URL.revokeObjectURL(url);
        } catch (error) {
            console.error('Error downloading file:', error);
        }
    }

    React.useEffect(() => {
        handleGetData();
    }, [ handleGetData]);

    return (
        <main>
            <div className="container-fluid">

                <div className="row mt-3">
                    <div className="col-md-12">
                        <h3><strong><i className='fa fa-user-alt'></i>REKOMENDASI PAJAK</strong></h3>
                    </div>
                </div>
                <hr />
                <div className="row mt-2">
                    <div className="table-responsive">
                        {loading ? (
                            <div className="d-flex justify-content-center align-items-center" style={{ height: '200px' }}>
                                <div className="spinner-border text-primary" role="status">
                                    <span className="visually-hidden">Loading...</span>
                                </div>
                            </div>
                        ) : (
                            <table className="tb-daftar-dinas mt-1">
                                <thead>
                                    <tr>
                                        <th>No</th>
                                        <th>Pembuat</th>
                                        <th>Penerima</th>
                                        <th>Nama Dokumen</th>
                                        <th>Nomor</th>
                                        <th>Tanggal</th>
                                        <th>Aksi</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {data_rekomendasi.map((item, index) => (
                                        <tr key={index}>
                                            <td>{index + 1}</td>
                                            <td>BADAN PENGELOLAAN KEUANGAN DAERAH</td>
                                            <td>{item.opd || '-'}</td>
                                            <td>{'Surat Rekomendasi Pajak'}</td>
                                            <td>{item.no_surat || '-'}</td>
                                            <td>{item.tgl_surat ? new Date(item.tgl_surat).toLocaleDateString('id-ID') : '-'}</td>
                                            <td>
                                                <Button variant="info" size="sm" onClick={() => handleDownloadSurat(item.nama_dokumen)}> <FaFileDownload /> Download</Button>
                                            </td>
                                        </tr>
                                    ))}
                                    {data_rekomendasi.length === 0 && (
                                        <tr>
                                            <td colSpan="6" className="text-center">Belum ada data rekomendasi pajak</td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        )}
                    </div>
                </div>
            </div>
        </main >

    )
}

export default Opd_rekomendasi_pajak